import { useTitle } from 'contexts/TitleContext'

export default function Title() {
  // Accede al contexto de título para posibles actualizaciones relacionadas
  const { title } = useTitle()

  return (
    <span className="pb-1 text-xl font-semibold leading-none text-white uppercase md:text-4xl">
      {title.name}
    </span>
  )
}
